import { render, staticRenderFns } from "./physicalShopReport.vue?vue&type=template&id=5510ac40&"
import script from "./physicalShopReport.vue?vue&type=script&lang=js&"
export * from "./physicalShopReport.vue?vue&type=script&lang=js&"
import style0 from "./physicalShopReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports